import {
  required,
  email,
  integer,
  maxLength,
}
from 'vuelidate/lib/validators'

export function normalize (text: string): string {
  return text.toLowerCase()
              .replace('đ', 'd')
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .replace('đ', 'd')
}

export function addThousandSeparator (number: number | string | null | undefined): string {
  if (number === undefined || number === null || number === '') {
    return ''
  }
  return number.toLocaleString('en-US')
}

export function isInt (text: string): boolean {
  const pattern = new RegExp(/^\d+$/)
  return pattern.test(text)
}

export function isIntOrFloat (text: string): boolean {
  const pattern = new RegExp(/^-?\d+(\.\d+)*$/)
  return pattern.test(text)
}

export const inputRules = {
  // @ts-expect-error
  required: (value: unknown) => required(value) || 'Trường này không được để trống.',
  // @ts-expect-error
  email: (value: string) => email(value) || 'Email không hợp lệ.',

  integer: (value: string) => {
    value = value.replaceAll(',', '')  // Remove thousand separator if any
    // @ts-expect-error
    return integer(value) || 'Trường này chỉ nhập số.'
  },

  maxLength: (max: number) => {
    const rule = maxLength(max)
    return (value: string) => rule(value) || `Không được vượt quá ${max} ký tự.`
  }
}

/**
 * Formatting
 */
export function round (amount: number, decimalPlaces?: number): number {
  if (decimalPlaces === undefined) decimalPlaces = 0
  const factor = 10 ** decimalPlaces
  return Math.round(amount * factor) / factor
}

export function formatMoney (amount: number | null, isMillion?: boolean): string {
  if (amount === null) return ''
  if (isMillion === undefined) isMillion = true
  if (isMillion) amount /= 1_000_000
  const formatted = addThousandSeparator(amount)
  return formatted
}

export function formatNumber (amount: number | null, decimalPlaces?: number): string {
  if (amount === null) return ''
  const rounded = round(amount, decimalPlaces)
  const formatted = addThousandSeparator(rounded)
  return formatted
}

export function formatPercentage (amount: number | null, decimalPlaces?: number, suffix?: string): string {
  if (amount === null) return ''
  if (suffix === undefined) suffix = '%'
  amount *= 100
  const rounded = round(amount, decimalPlaces)
  let formatted = addThousandSeparator(rounded)
  formatted += suffix
  return formatted
}

export function formatDateTime (
  dateTime: Date | string, dateSeparator?: string, timeSeparator?: string,
  includeSeconds?: boolean, valueWhenNull?: string
): string {
  if (valueWhenNull === undefined) valueWhenNull = ''
  if (dateTime === null || dateTime === undefined || dateTime === '') {
    return valueWhenNull
  }
  if (dateSeparator === undefined) dateSeparator = '/'
  if (timeSeparator === undefined) timeSeparator = ':'
  if (includeSeconds === undefined) includeSeconds = false

  const dateTimeObj = new Date(dateTime)
  let formattedDateTime = (
    dateTimeObj.getDate().toString().padStart(2, '0') + dateSeparator +
    (dateTimeObj.getMonth() + 1).toString().padStart(2, '0') + dateSeparator +
    dateTimeObj.getFullYear() + ' ' +
    dateTimeObj.getHours().toString().padStart(2, '0') + timeSeparator +
    dateTimeObj.getMinutes().toString().padStart(2, '0')
  )
  if (includeSeconds) {
    formattedDateTime += (timeSeparator + dateTimeObj.getSeconds())
  }
  return formattedDateTime
}
